import { ChangeDetectionStrategy, Component } from '@angular/core';
import { getRouterLink, ROUTE_PATH } from '@common/types/route-path.enum';
import { CookiesConsentService } from 'src/services/cookies-consent.service';
import { I18nService } from '../../../services/i18n.service';

@Component({
	selector: 'app-cookies-consent',
	templateUrl: './cookies-consent.component.html',
	styleUrls: ['./cookies-consent.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiesConsentComponent {
	getRouterLink = getRouterLink;
	ROUTE_PATH = ROUTE_PATH;

	constructor(
		public cookiesConsentService: CookiesConsentService,
		private i18nService: I18nService
	) {}

	onConsentCookies(event: MouseEvent) {
		event.preventDefault();

		this.cookiesConsentService.cookiesConsented();
	}

	get languageName() {
		return this.i18nService.languageName;
	}
}
